// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfigureGame_container__27E2W","label":"ConfigureGame_label__jes24","textarea":"ConfigureGame_textarea__2aqw7","link":"ConfigureGame_link__3PTPk"};